<!-- 首页 -->
<template>
  <div>
    <header class="t-blue tac pt-40">请选择服务</header>
    <div class="p-40">
      <div
        v-for="(item, index) in bannerList"
        :key="item.code"
        :class="[`banner-${index + 1}`]"
        class="p-40 mb-40 tac border-radius-10 banner"
        @click="handleClickBanner(item)"
      >
        <p>{{ item.text }}</p>
        <div class="btn">立即申请</div>
      </div>
    </div>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from "@/components/CFooter.vue"
export default {
  name: "Home",
  components: {
    CFooter,
  },
  data: () => {
    return {
      bannerList: [
        {
          code: "1",
          text: "入户广州",
          url: "https://nanfang.parameters.cn/web/",
        },
        {
          code: "2",
          text: "劳动补贴申领",
        },
        {
          code: "3",
          text: "专业技术资格服务",
        },
      ],
    }
  },
  mounted() {},
  methods: {
    handleClickBanner(item) {
      if (item.url) {
        location.href = item.url
        return
      }
      this.$router.push({
        path: `/sub/${item.code}`,
      })
    },
  },
}
</script>

<style lang="scss" scope>
.banner {
  color: #fff;
  p {
    font-size: 40px;
    font-weight: bold;
  }
  .btn {
    margin-top: 40px;
    font-size: 24px;
    border-radius: 50px;
    background: #fff;
    display: inline-block;
    padding: 10px 40px;
  }
}
.banner-1 {
  background: #0986ff;
  .btn {
    color: #0986ff;
  }
}
.banner-2 {
  background: #274fe0;
  .btn {
    color: #274fe0;
  }
}
.banner-3 {
  background: #5f2adc;
  .btn {
    color: #5f2adc;
  }
}
</style>
